// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__8LPiX","modalBody":"MealsPop_modalBody__QTdQh"};